<div class="container-fluid my-2 px-0">

  <div class="header-container">
    <div class="booking-table">
      <div class="header-item">{{ 'SHUTTLE_CHECKIN.FROM_ARLANDA_TO_PARKING' | transloco}}</div>

      <!-- Tab 1: Ready to transfer -->
      <div class="header-title">{{ 'SHUTTLE_CHECKIN.READY_TO_TRANSFER' | transloco }}</div>
      <mat-card>
        <mat-card-content>
          <div>
            <mat-card appearance="outlined" matRipple class="group-card">
              <div class="checkbox-flex-container">
                <mat-checkbox [checked]="showCustDetailsPickupArrival"
                  (change)="changeShowCustDetailsPickupArrival($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox [checked]="showFlightDetailsPickupArrival"
                  (change)="changeShowFlightDetailsPickupArrival($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-icon class="clickable" (click)="setOrderShuttlesPickup(orderShuttles)">refresh</mat-icon>
              </div>
            </mat-card>
            <table>
              <tr>
                <th><mat-icon>badge</mat-icon></th>
                <th><mat-icon>group</mat-icon></th>
                <th><mat-icon>calendar_month</mat-icon></th>
                <th><mat-icon>schedule</mat-icon></th>
                <th><mat-icon>flight</mat-icon></th>
                <th><mat-icon>numbers</mat-icon></th>
              </tr>
              @for (orderShuttle of orderShuttlesPickupArrival; track orderShuttle) {
              <tr (click)="goToOrder(orderShuttle)"
                [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
                <td>
                  <div [style.color]="orderShuttle.problemFlight?.arrival ? 'red' : 'black'" class="border-none">
                    {{ orderShuttle.firstName }} {{ orderShuttle.lastName}}
                  </div>
                  @if (isHotel(orderShuttle)) {
                  <mat-icon class="icon-bottom ms-1"
                    class="icon-scale-small">hotel</mat-icon>
                  }
                  @if (orderShuttle.hasDevice) {
                  <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
                  }
                  @if (orderShuttle.extra?.pressedButtonInApp) {
                  <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
                  }
                  @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
                  <mat-icon class="icon-bottom"
                    [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
                  </mat-icon>
                  @if (orderShuttle.orderSafe?.hookNo) {
                  <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
                  }
                  }
                </td>
                <td> {{ orderShuttle.passengers }}</td>
                <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}"> {{ orderShuttle.shuttleDate |
                  date:'HH:mm' }}</td>
                <td title="{{orderShuttle.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}"
                  [ngStyle]="{color:orderShuttle.isReadyForPickup?'green':'black'}">
                  {{ orderShuttle.shuttleDateNew | date: 'HH:mm' }}</td>
                @if (!orderShuttle.arrivalVM) {
                <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
                  {{ orderShuttle.terminal }}</td>
                }
                @if (orderShuttle.arrivalVM) {
                <td
                  [ngStyle]="{color:orderShuttle.arrivalVM.terminalName=='Terminal 5'||orderShuttle.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">
                  {{orderShuttle.arrivalVM.terminalName}}</td>
                }
                <td> {{ orderShuttle.orderNr }}</td>
              </tr>
              @if ((orderShuttle.departureVM || orderShuttle.arrivalVM) && showFlightDetailsPickupArrival) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="5">
                  @if (orderShuttle.departureVM && showFlightDetailsPickupArrival) {
                  <div>
                    <app-back-office24-ordershuttlebus-departure
                      [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
                  </div>
                  }
                  @if (orderShuttle.arrivalVM && showFlightDetailsPickupArrival) {
                  <div>
                    <app-back-office24-ordershuttlebus-arrival
                      [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
                  </div>
                  }
                </td>
              </tr>
              }
              @if (showCustDetailsPickupArrival) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="5">
                  @if (orderShuttle.cellular) {
                  <span>Contact:
                    {{orderShuttle.cellular}}</span>
                  }
                  @if (orderShuttle.comment) {
                  <span>Comments:
                    {{orderShuttle.comment}}</span>
                  }
                </td>
              </tr>
              }
              }
            </table>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Tab 2: Övriga kunder -->
      <div class="header-title">{{ 'SHUTTLE_CHECKIN.OTHER_CUSTOMERS' | transloco }}</div>
      <mat-card>
        <mat-card-content>
          <div>
            @if (orderShuttlesOtherArrival && orderShuttlesOtherArrival.length > 0) {
            <mat-card appearance="outlined" matRipple class="group-card">
              <div class="checkbox-flex-container">
                <mat-checkbox [checked]="showCustDetailsOtherArrival"
                  (change)="changeShowCustDetailsOtherArrival($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox [checked]="showFlightDetailsOtherArrival"
                  (change)="changeShowFlightDetailsOtherArrival($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-icon class="clickable" (click)="getOrderShuttlesOther()">refresh</mat-icon>
              </div>
            </mat-card>
            }
            <table>
              <tr>
                <th><mat-icon>badge</mat-icon></th>
                <th><mat-icon>group</mat-icon></th>
                <th><mat-icon>calendar_month</mat-icon></th>
                <th><mat-icon>schedule</mat-icon></th>
                <th><mat-icon>flight</mat-icon></th>
                <th><mat-icon>numbers</mat-icon></th>

              </tr>
              @for (orderShuttle of orderShuttlesOtherArrival; track orderShuttle) {
              <tr (click)="goToOrder(orderShuttle)"
                [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
                <td>
                  <div [style.color]="orderShuttle.problemFlight?.arrival ? 'red' : 'black'" class="border-none">
                    {{ orderShuttle.firstName }} {{ orderShuttle.lastName}}
                  </div>
                  @if (isHotel(orderShuttle)) {
                  <mat-icon class="icon-bottom ms-1"
                    class="icon-scale-small">hotel</mat-icon>
                  }
                  @if (orderShuttle.hasDevice) {
                  <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
                  }
                  @if (orderShuttle.extra?.pressedButtonInApp) {
                  <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
                  }
                  @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
                  <mat-icon class="icon-bottom"
                    [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
                  </mat-icon>
                  @if (orderShuttle.orderSafe?.hookNo) {
                  <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
                  }
                  }
                </td>
                <td> {{ orderShuttle.passengers }}</td>
                <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}"> {{ orderShuttle.shuttleDate |
                  date:'yyyy-MM-dd' }} </td>
                <td title="{{orderShuttle.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}"
                  [ngStyle]="{color:orderShuttle.isReadyForPickup?'green':'black'}">
                  {{ orderShuttle.shuttleDateNew | date: 'HH:mm' }}
                </td>
                @if (!orderShuttle.arrivalVM) {
                <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
                  {{ orderShuttle.terminal }}</td>
                }
                @if (orderShuttle.arrivalVM) {
                <td
                  [ngStyle]="{color:orderShuttle.arrivalVM.terminalName=='Terminal 5'||orderShuttle.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">
                  {{orderShuttle.arrivalVM.terminalName}}</td>
                }
                <td> {{ orderShuttle.orderNr }}</td>
              </tr>
              @if ((orderShuttle.departureVM || orderShuttle.arrivalVM) && showFlightDetailsOtherArrival) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="5">
                  @if (orderShuttle.departureVM && showFlightDetailsOtherArrival) {
                  <div>
                    <app-back-office24-ordershuttlebus-departure
                      [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
                  </div>
                  }
                  @if (orderShuttle.arrivalVM && showFlightDetailsOtherArrival) {
                  <div>
                    <app-back-office24-ordershuttlebus-arrival
                      [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
                  </div>
                  }
                </td>
              </tr>
              }
              @if (showCustDetailsOtherArrival) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="5">
                  @if (orderShuttle.cellular) {
                  <span>Contact:
                    {{orderShuttle.cellular}}</span>
                  }
                  @if (orderShuttle.comment) {
                  <span>Comments:
                    {{orderShuttle.comment}}</span>
                  }
                </td>
              </tr>
              }
              }
            </table>
          </div>
        </mat-card-content>
      </mat-card>

    </div>

    <div class="booking-table">
      <div class="header-item">{{ 'SHUTTLE_CHECKIN.FROM_PARKING_TO_ARLANDA' | transloco }}</div>

      <!-- Tab 1: Redo för transfer -->
      <div class="header-title">{{ 'SHUTTLE_CHECKIN.READY_TO_TRANSFER' | transloco }}</div>
      <mat-card>
        <mat-card-content>
          <div>
            <mat-card appearance="outlined" matRipple class="group-card">
              <div class="checkbox-flex-container">
                <mat-checkbox [checked]="showCustDetailsPickupDeparture"
                  (change)="changeShowCustDetailsPickupDeparture($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox [checked]="showFlightDetailsPickupDeparture"
                  (change)="changeShowFlightDetailsPickupDeparture($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-icon class="clickable" (click)="setOrderShuttlesPickup(orderShuttles)">refresh</mat-icon>
              </div>
            </mat-card>
            <table>
              <tr>
                <th><mat-icon>badge</mat-icon></th>
                <th><mat-icon>group</mat-icon></th>
                <th><mat-icon>place</mat-icon></th>
                <th><mat-icon>airport_shuttle</mat-icon></th>
                <th><mat-icon>flight</mat-icon></th>
                <th><mat-icon>numbers</mat-icon></th>
              </tr>
              @for (orderShuttle of orderShuttlesPickupDeparture; track orderShuttle) {
              <tr (click)="goToOrder(orderShuttle)"
                [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
                <td>
                  <div [style.color]="orderShuttle.problemFlight?.departure ? 'red' : 'black'" class="border-none">
                    {{ orderShuttle.firstName }} {{ orderShuttle.lastName}}
                  </div>
                  @if (isHotel(orderShuttle)) {
                  <mat-icon class="icon-bottom ms-1"
                    class="icon-scale-small">hotel</mat-icon>
                  }
                  @if (orderShuttle.hasDevice) {
                  <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
                  }
                  @if (orderShuttle.extra?.pressedButtonInApp) {
                  <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
                  }
                  @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
                  <mat-icon class="icon-bottom"
                    [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
                  </mat-icon>
                  @if (orderShuttle.orderSafe?.hookNo) {
                  <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
                  }
                  }
                </td>
                <td> {{ orderShuttle.passengers }}</td>
                @if (orderShuttle.orderParkingParkingSiteName) {
                <td title="{{orderShuttle.orderParkingParkingSiteName}}">
                  @let hotelName = displayHotelName(orderShuttle.organizationId);
                  @if(hotelName){
                  {{hotelName}}
                  }@else{
                  @let parking = removeLastPart($safeNavigationMigration(orderShuttle?.orderParkingParkingSiteName));
                  <span class="border-none" [style.color]="parking === 'FP2' ? 'red' : 'inherit'">
                    {{ parking }}
                  </span>
                  }
                </td>
                }
                @if (!orderShuttle.orderParkingParkingSiteName) {
                <td>
                  {{displayRouteName(orderShuttle)}}</td>
                }
                @if(orderShuttle.orderParkingParkingSiteName){
                <td title="{{orderShuttle.shuttleUpdated | date:'yyyy-MM-dd HH:mm'}}">
                  {{
                  orderShuttle.shuttleUpdated | date: 'HH:mm' }}</td>
                }
                @if(!orderShuttle.orderParkingParkingSiteName){
                <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}">
                  {{
                  orderShuttle.shuttleDate | date: 'HH:mm' }}</td>
                }
                @if (!orderShuttle.departureVM) {
                <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
                  {{ orderShuttle.terminal }}</td>
                }
                @if (orderShuttle.departureVM) {
                <td
                  [ngStyle]="{color:orderShuttle.departureVM.terminalName=='Terminal 5'||orderShuttle.departureVM.terminalName=='Terminal 4'?'black':'red'}">
                  {{orderShuttle.departureVM.terminalName}}</td>
                }
                <td> {{ orderShuttle.orderNr }}</td>
              </tr>
              @if ((orderShuttle.departureVM || orderShuttle.arrivalVM) && showFlightDetailsPickupDeparture) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="6">
                  @if (orderShuttle.departureVM && showFlightDetailsPickupDeparture) {
                  <div>
                    <app-back-office24-ordershuttlebus-departure
                      [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
                  </div>
                  }
                  @if (orderShuttle.arrivalVM && showFlightDetailsPickupDeparture) {
                  <div>
                    <app-back-office24-ordershuttlebus-arrival
                      [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
                  </div>
                  }
                </td>
              </tr>
              }
              @if (showCustDetailsPickupDeparture) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="6">
                  @if (orderShuttle.cellular) {
                  <span>Contact:
                    {{orderShuttle.cellular}}</span>
                  }
                  @if (orderShuttle.comment) {
                  <span>Comments:
                    {{orderShuttle.comment}}</span>
                  }
                </td>
              </tr>
              }
              }
            </table>
          </div>

        </mat-card-content>
      </mat-card>

      <!-- Tab 2: Övriga kunder -->
      <div class="header-title">{{ 'SHUTTLE_CHECKIN.OTHER_CUSTOMERS' | transloco }}</div>
      <mat-card>
        <mat-card-content>
          <div>
            @if (orderShuttlesOtherDeparture && orderShuttlesOtherDeparture.length > 0) {
            <mat-card appearance="outlined" matRipple class="group-card">
              <div class="checkbox-flex-container">
                <mat-checkbox [checked]="showCustDetailsOtherDeparture"
                  (change)="changeShowCustDetailsOtherDeparture($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox [checked]="showFlightDetailsOtherDeparture"
                  (change)="changeShowFlightDetailsOtherDeparture($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                <mat-icon class="clickable" (click)="getOrderShuttlesOther()">refresh</mat-icon>
              </div>
            </mat-card>
            }
            <table>
              <tr>
                <th><mat-icon>badge</mat-icon></th>
                <th><mat-icon>group</mat-icon></th>
                <th><mat-icon>place</mat-icon></th>
                <th><mat-icon>schedule</mat-icon></th>
                <th><mat-icon>flight</mat-icon></th>
                <th><mat-icon>numbers</mat-icon></th>
              </tr>
              @for (orderShuttle of orderShuttlesOtherDeparture; track orderShuttle) {
              <tr (click)="goToOrder(orderShuttle)"
                [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
                <td>
                  <div [style.color]="orderShuttle.problemFlight?.departure ? 'red' : 'black'">
                    {{ orderShuttle.firstName }} {{ orderShuttle.lastName}}
                  </div>
                  @if (isHotel(orderShuttle)) {
                  <mat-icon class="icon-bottom ms-1"
                    class="icon-scale-small">hotel</mat-icon>
                  }
                  @if (orderShuttle.hasDevice) {
                  <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
                  }
                  @if (orderShuttle.extra?.pressedButtonInApp) {
                  <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
                  }
                  @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
                  <mat-icon class="icon-bottom"
                    [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
                  </mat-icon>
                  @if (orderShuttle.orderSafe?.hookNo) {
                  <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
                  }
                  }
                </td>
                <td> {{ orderShuttle.passengers }}</td>
                @if (orderShuttle.orderParkingParkingSiteName) {
                <td title="{{orderShuttle.orderParkingParkingSiteName}}">
                  @let hotelName = displayHotelName(orderShuttle.organizationId);
                  @if(hotelName){
                  {{hotelName}}
                  }@else{
                  @let parking = removeLastPart($safeNavigationMigration(orderShuttle?.orderParkingParkingSiteName));
                  <span class="border-none" [style.color]="parking === 'FP2' ? 'red' : 'inherit'">
                    {{ parking }}
                  </span>
                  }
                </td>
                }
                @if (!orderShuttle.orderParkingParkingSiteName) {
                <td>
                  {{displayRouteName(orderShuttle)}}</td>
                }
                <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}">
                  {{
                  orderShuttle.shuttleDate | date: 'HH:mm' }}</td>
                @if (!orderShuttle.departureVM) {
                <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
                  {{ orderShuttle.terminal }}</td>
                }
                @if (orderShuttle.departureVM) {
                <td
                  [ngStyle]="{color:orderShuttle.departureVM.terminalName=='Terminal 5'||orderShuttle.departureVM.terminalName=='Terminal 4'?'black':'red'}">
                  {{orderShuttle.departureVM.terminalName}}</td>
                }
                <td> {{ orderShuttle.orderNr }}</td>
              </tr>
              @if ((orderShuttle.departureVM || orderShuttle.arrivalVM) && showFlightDetailsOtherDeparture) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="6">
                  @if (orderShuttle.departureVM && showFlightDetailsOtherDeparture) {
                  <div>
                    <app-back-office24-ordershuttlebus-departure
                      [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
                  </div>
                  }
                  @if (orderShuttle.arrivalVM && showFlightDetailsOtherDeparture) {
                  <div>
                    <app-back-office24-ordershuttlebus-arrival
                      [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
                  </div>
                  }
                </td>
              </tr>
              }
              @if (showCustDetailsOtherDeparture) {
              <tr
                [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
                <td colspan="6">
                  @if (orderShuttle.cellular) {
                  <span>Contact:
                    {{orderShuttle.cellular}}</span>
                  }
                  @if (orderShuttle.comment) {
                  <span>Comments:
                    {{orderShuttle.comment}}</span>
                  }
                </td>
              </tr>
              }
              }
            </table>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>